import { render, staticRenderFns } from "./PCContainer.vue?vue&type=template&id=2d463388&scoped=true"
import script from "./PCContainer.vue?vue&type=script&lang=js"
export * from "./PCContainer.vue?vue&type=script&lang=js"
import style0 from "./PCContainer.vue?vue&type=style&index=0&id=2d463388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d463388",
  null
  
)

export default component.exports